import { render, staticRenderFns } from "./tigerTerms.vue?vue&type=template&id=6bd89be0"
import script from "./tigerTerms.vue?vue&type=script&lang=js"
export * from "./tigerTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports